import React from "react";
import PropTypes from "prop-types";
import style from "./base-menu.css";

function BaseMenu({ children }) {
    return (
        <>
            <div className={style.menuContent}>{children}</div>
        </>
    );
}

export default BaseMenu;

BaseMenu.propTypes = {
    children: PropTypes.node
};
